export const betaVendors = [
    'photobox.co.uk',
    'photobox.fr',
    'photobox.ie',
    'photobox.it',
    'photobox.dk',
    'hofmann.es',
    'hofmann.pt',
];
